"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = exports.OPTION_DEFAULT_VALUE = exports.KERNEL_STRING_TYPE = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _LearningBase2 = _interopRequireDefault(require("./LearningBase"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _Utils = _interopRequireDefault(require("./Utils"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SVM = require('libsvm-js/asm');
var classes = exports.classes = ['ai_learning_train', 'ai_learning_svm', 'svm_attr_1', 'svm_attr_2', 'svm_attr_3', 'svm_attr_4', 'svm_attr_5', 'svm_attr_6'];
var KERNEL_STRING_TYPE = exports.KERNEL_STRING_TYPE = {
  LINEAR: 'linear',
  POLYNOMIAL: 'polynomial',
  RBF: 'rbf'
};
var OPTION_DEFAULT_VALUE = exports.OPTION_DEFAULT_VALUE = {
  epochs: 30,
  batchSize: 16,
  k: 4,
  initialCentroids: 'kmpp',
  neighbors: 10,
  validationRate: 0.25,
  C: 0.00001,
  degree: 3,
  gamma: 1
};
var Svm = /*#__PURE__*/function (_LearningBase) {
  function Svm() {
    var _this;
    (0, _classCallCheck2["default"])(this, Svm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Svm, [].concat(args));
    (0, _defineProperty2["default"])(_this, "type", 'svm');
    return _this;
  }
  (0, _inherits2["default"])(Svm, _LearningBase);
  return (0, _createClass2["default"])(Svm, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2,
        _table$select3;
      var name = _ref.name,
        url = _ref.url,
        result = _ref.result,
        table = _ref.table,
        trainParam = _ref.trainParam,
        modelId = _ref.modelId,
        loadModel = _ref.loadModel;
      this.name = name;
      this.trainParam = trainParam;
      this.result = result;
      this.table = table;
      this.loadModel = loadModel;
      this.trainCallback = function (value) {
        _this2.view.setValue(value);
      };
      // train 확인 필요
      this.trained = true;
      this.chartEnable = false;
      this.attrLength = (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0;
      this.fields = table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      this.predictFields = table === null || table === void 0 || (_table$select3 = table.select) === null || _table$select3 === void 0 || (_table$select3 = _table$select3[1]) === null || _table$select3 === void 0 ? void 0 : _table$select3.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      if (this.url !== url || this.modelId !== modelId) {
        this.load(url, modelId);
        this.url = url;
        this.modelId = modelId;
      }
    }
  }, {
    key: "checkTrainOptionValidation",
    value: function checkTrainOptionValidation() {
      var _this$trainParam = this.trainParam,
        kernel = _this$trainParam.kernel,
        C = _this$trainParam.C,
        degree = _this$trainParam.degree,
        gamma = _this$trainParam.gamma;
      if (!kernel || !C || !degree || !gamma) {
        throw new Error("can't train: trainOptions contain undefined");
      }
      switch (kernel) {
        case KERNEL_STRING_TYPE.LINEAR:
          if (degree !== OPTION_DEFAULT_VALUE.degree || gamma !== OPTION_DEFAULT_VALUE.gamma) {
            throw new Error("can't train: invalid kernelOption. kernel type ".concat(KERNEL_STRING_TYPE.LINEAR));
          }
          break;
        case KERNEL_STRING_TYPE.POLYNOMIAL:
          if (gamma !== OPTION_DEFAULT_VALUE.gamma) {
            throw new Error("can't train: invalid kernelOption. kernel type ".concat(KERNEL_STRING_TYPE.POLYNOMIAL));
          }
          break;
        case KERNEL_STRING_TYPE.RBF:
          if (degree !== OPTION_DEFAULT_VALUE.degree) {
            throw new Error("can't train: invalid kernelOption. kernel type ".concat(KERNEL_STRING_TYPE.RBF));
          }
          break;
        default:
      }
    }
  }, {
    key: "train",
    value: function () {
      var _train = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this$trainParam2, _this$trainParam2$tes, testRate, C, kernel, degree, gamma, _this$getData, trainX, trainY, testArr, select, fields, PREDICT_STR2NUM_MAP, numClass, svmTrainOption, _this$evaluate, confusionMatrix, score, accuracy, f1, precision, recall;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.trained = false;
              this.setTable();
              this.trainCallback(1);
              this.checkTrainOptionValidation();
              _this$trainParam2 = this.trainParam, _this$trainParam2$tes = _this$trainParam2.testRate, testRate = _this$trainParam2$tes === void 0 ? 0.2 : _this$trainParam2$tes, C = _this$trainParam2.C, kernel = _this$trainParam2.kernel, degree = _this$trainParam2.degree, gamma = _this$trainParam2.gamma;
              _this$getData = this.getData(testRate, this.table), trainX = _this$getData.trainX, trainY = _this$getData.trainY, testArr = _this$getData.testArr, select = _this$getData.select, fields = _this$getData.fields, PREDICT_STR2NUM_MAP = _this$getData.PREDICT_STR2NUM_MAP, numClass = _this$getData.numClass;
              svmTrainOption = {
                kernel: kernel,
                C: C,
                degree: degree,
                gamma: gamma
              };
              this.predictValueMap = Object.fromEntries(Object.entries(PREDICT_STR2NUM_MAP).map(function (_ref2) {
                var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];
                return [value, key];
              }));
              this.trainCallback(30);
              this.model = createModel();
              trainModel(this.model, trainX, trainY, svmTrainOption);
              this.trainCallback(80);
              _this$evaluate = this.evaluate(this.model, testArr, numClass), confusionMatrix = _this$evaluate.confusionMatrix, score = _this$evaluate.score;
              accuracy = score.accuracy, f1 = score.f1, precision = score.precision, recall = score.recall;
              this.trainCallback(100);
              this.trained = true;
              this.result = {
                select: select,
                fields: fields,
                confusionMatrix: confusionMatrix,
                accuracy: accuracy,
                f1: f1,
                valueMap: this.predictValueMap,
                precision: precision,
                recall: recall
              };
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function train() {
        return _train.apply(this, arguments);
      }
      return train;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(url, modelId) {
        var data, serializeModel, result;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.loadModel({
                url: url,
                modelId: modelId
              });
            case 1:
              data = _context2.sent;
              if (data) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              serializeModel = data.serializeModel, result = data.result;
              this.model = SVM.load(serializeModel);
              this.valueMap = result === null || result === void 0 ? void 0 : result.valueMap;
              this.result = result;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }() // INFO: 예상치 전체를 가져옴. Deeplearning 레포의 predictArrays와 동일
  }, {
    key: "predict",
    value: function () {
      var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(array) {
        var _this3 = this;
        var xs, preds;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.model) {
                _context3.next = 1;
                break;
              }
              throw new Error("can't predict: no model");
            case 1:
              xs = [array];
              preds = this.model.predict(xs);
              this.predictResult = preds.map(function (target) {
                return {
                  className: _this3.valueMap[target + 1],
                  probability: 1
                };
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function predict(_x3) {
        return _predict.apply(this, arguments);
      }
      return predict;
    }()
  }, {
    key: "getData",
    value: function getData(testRate, data) {
      var STR2NUM_MAP = {};
      var STR2NUM_MAP_COUNT = {};
      var _data$select = data.select,
        select = _data$select === void 0 ? [[0], [1]] : _data$select,
        table = data.data,
        fields = data.fields;
      var _select = (0, _slicedToArray2["default"])(select, 2),
        attr = _select[0],
        predict = _select[1];
      var filtered = table.filter(function (row) {
        return !select[0].some(function (selected) {
          return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
        });
      });
      var dataArray = filtered.map(function (row) {
        return {
          x: attr.map(function (i) {
            return parseFloat(row[i]) || 0;
          }),
          y: _Utils["default"].stringToNumber(predict[0], row[predict[0]], STR2NUM_MAP, STR2NUM_MAP_COUNT)
        };
      }).map(function (row) {
        return {
          x: row.x,
          y: row.y - 1
        };
      });
      var _this$sliceArray = this.sliceArray(dataArray, testRate),
        trainArr = _this$sliceArray.trainArr,
        testArr = _this$sliceArray.testArr;
      return {
        trainX: trainArr.map(function (v) {
          return v.x;
        }),
        trainY: trainArr.map(function (v) {
          return v.y;
        }),
        testArr: testArr,
        select: select,
        fields: fields,
        PREDICT_STR2NUM_MAP: _objectSpread({}, STR2NUM_MAP[predict[0]]),
        numClass: STR2NUM_MAP_COUNT[predict[0]]
      };
    }
  }, {
    key: "sliceArray",
    value: function sliceArray(dataArray, testRate) {
      _Utils["default"].shuffle(dataArray);
      var testNum = Math.floor(dataArray.length * testRate);
      var testArr = dataArray.slice(0, testNum);
      var trainArr = dataArray.slice(testNum, dataArray.length);
      return {
        trainArr: trainArr,
        testArr: testArr
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(model, validateData, numClass) {
      var xs = validateData.map(function (data) {
        return data.x;
      });
      var ys = validateData.map(function (data) {
        return data.y;
      });
      var predictYs = model.predict(xs);
      var length = predictYs.length;
      var confusionMatrix = Array(numClass).fill(0).map(function () {
        return Array(numClass).fill(0);
      });
      for (var idx = 0; idx < length; idx++) {
        confusionMatrix[ys[idx]][predictYs[idx]]++;
      }
      var score = _Utils["default"].getScores(confusionMatrix, numClass);
      return {
        confusionMatrix: confusionMatrix,
        score: score
      };
    }
  }]);
}(_LearningBase2["default"]);
var _default = exports["default"] = Svm;
function createModel() {
  return new SVM({
    type: SVM.SVM_TYPES.C_SVC,
    probabilityEstimates: true
  });
}
function trainModel(model, samples, labels, svmTrainOption) {
  var kernelType;
  if (svmTrainOption.kernel === KERNEL_STRING_TYPE.LINEAR) {
    kernelType = SVM.KERNEL_TYPES.LINEAR;
  } else if (svmTrainOption.kernel === KERNEL_STRING_TYPE.POLYNOMIAL) {
    kernelType = SVM.KERNEL_TYPES.POLYNOMIAL;
  } else if (svmTrainOption.kernel === KERNEL_STRING_TYPE.RBF) {
    kernelType = SVM.KERNEL_TYPES.RBF;
  } else {
    throw new Error("can't create model: unexpected kernel type");
  }
  model.free();
  model.kernel = kernelType;
  model.cost = svmTrainOption.C;
  model.degree = svmTrainOption.degree;
  model.gamma = svmTrainOption.gamma;
  model.train(samples, labels);
}